export default {
  FETCH_REPORT_TYPE_CODE: 'FETCH_REPORT_TYPE_CODE',
  FETCH_REPORT_TYPE_CODE_SUCCESS: 'FETCH_REPORT_TYPE_CODE_SUCCESS'
}
